require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-big-announcement-foundations-courses-starting-soon.json") })
        }
      }, "path---blog-big-announcement-foundations-courses-starting-soon");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-big-announcement-foundations-courses-starting-soon!./.cache/json/blog-big-announcement-foundations-courses-starting-soon.json
// module id = 726
// module chunks = 231608221292675